module.exports = {
	"id": "TZ",
	"name": "Tanzania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.00104,
			"10": 0.00416,
			"11": 0.02496,
			"12": null,
			"13": 0.00104,
			"14": 0.00208,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.00104,
			"19": null,
			"20": 0.00208,
			"21": 0.00728,
			"22": 0.00624,
			"23": 0.00208,
			"24": null,
			"25": 0.00208,
			"26": 0.00208,
			"27": 0.00208,
			"28": 0.00416,
			"29": 0.00624,
			"30": 0.00104,
			"31": 0.01144,
			"32": null,
			"33": 0.01872,
			"34": 0.00104,
			"35": 0.00104,
			"36": 0.00416,
			"37": null,
			"38": 0.00312,
			"39": 0.00312,
			"40": 0.0052,
			"41": 0.00104,
			"42": 0.00416,
			"43": 0.06968,
			"44": 0.00312,
			"45": 0.02912,
			"46": 0.00728,
			"47": 0.01664,
			"48": 0.00832,
			"49": 0.11128,
			"50": 0.02184,
			"51": 0.12688,
			"52": 0.04576,
			"53": 2.88496,
			"54": 1.42064,
			"55": 0.0156,
			"56": 0.00416,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.00416,
			"4": 0.01664,
			"5": 0.0052,
			"6": 0.0052,
			"7": 0.00416,
			"8": 0.0052,
			"9": 0.00312,
			"10": 0.00832,
			"11": 0.0208,
			"12": 0.01768,
			"13": 0.01768,
			"14": 0.01248,
			"15": 0.00936,
			"16": 0.01456,
			"17": 0.01976,
			"18": 0.01144,
			"19": 0.00832,
			"20": 0.00728,
			"21": 0.01248,
			"22": 0.00312,
			"23": 0.01144,
			"24": 0.00624,
			"25": 0.00416,
			"26": 0.0052,
			"27": 0.00312,
			"28": 0.00416,
			"29": 0.02704,
			"30": 0.0208,
			"31": 0.00832,
			"32": 0.00936,
			"33": 0.01248,
			"34": 0.01248,
			"35": 0.01352,
			"36": 0.0104,
			"37": 0.02184,
			"38": 0.0156,
			"39": 0.01456,
			"40": 0.0156,
			"41": 0.01352,
			"42": 0.01976,
			"43": 0.1352,
			"44": 0.0676,
			"45": 0.03328,
			"46": 0.03744,
			"47": 0.30576,
			"48": 0.2496,
			"49": 1.18976,
			"50": 0.14872,
			"51": 0.00312,
			"52": null,
			"3.5": 0.00208,
			"3.6": 0.00624
		},
		"opera": {
			"9": null,
			"11": 0.00104,
			"12": 0.00416,
			"15": 0.00312,
			"16": null,
			"17": 0.00416,
			"18": 0.00312,
			"19": 0.00312,
			"20": 0.00208,
			"21": null,
			"22": 0.00416,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00208,
			"29": 0.00728,
			"30": 0.00728,
			"31": 0.00104,
			"32": 0.00312,
			"33": 0.01248,
			"34": 0.00624,
			"35": 0.01248,
			"36": 0.02808,
			"37": 0.43056,
			"38": 0.00728,
			"39": 0.01976,
			"40": 0.27664,
			"41": 0.03744,
			"42": 0.00208,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.00208,
			"11.1": 0.00104,
			"11.5": 0.00208,
			"11.6": 0.0052,
			"12.1": 0.0156
		},
		"safari": {
			"0": null,
			"4": 0.00208,
			"5": 0.00312,
			"6": 0.0104,
			"7": 0.00416,
			"8": 0.0156,
			"9": 0.02288,
			"10": 0.07072,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0104,
			"6.1": 0.00104,
			"7.1": 0.00208,
			"9.1": 0.078
		},
		"ios_saf": {
			"8": 0,
			"10": 0.336876602831,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0090784346378,
			"8.1-8.4": 0.0167720233139,
			"9.0-9.2": 0.00800133222315,
			"9.3": 0.122071606994
		},
		"android": {
			"3": 0,
			"4": 0.0739026356589,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00923782945736,
			"4.1": 0.266577364341,
			"4.2-4.3": 0.666443410853,
			"4.4": 1.52820093023,
			"4.4.3-4.4.4": 1.54139782946
		},
		"ie": {
			"6": 0.0052407310705,
			"7": 0.0010481462141,
			"8": 0.103766475196,
			"9": 0.0188666318538,
			"10": 0.031444386423,
			"11": 0.240025483029,
			"5.5": null
		},
		"op_mob": {
			"0": 4.7214144072,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.1311504002
		},
		"edge": {
			"12": 0.0416,
			"13": 0.05616,
			"14": 0.05096
		},
		"ie_mob": {
			"10": 0.0812709859155,
			"11": 0.330889014085
		},
		"bb": {
			"7": 0.0224,
			"10": null
		},
		"samsung": {
			"0": 0.77056
		},
		"and_uc": {
			"0": 7.41888
		},
		"op_mini": {
			"0": 63.6107951926
		},
		"and_chr": {
			"0": 7.26248
		},
		"and_ff": {
			"0": 0.00896
		}
	},
	"total": 98.1351118538
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TZ.json
 ** module id = 669
 ** module chunks = 0
 **/